// Smart Gymnastics brand colours
export const PINK   = '#F2A2B3'; // brand pink (soft)
export const BLUE   = '#4682B4'; // brand steel blue
export const PINK_DARK  = '#D4607A'; // darker pink for active hearts / CTAs
export const BLUE_DARK  = '#2F5F8F'; // darker blue for pressed states
export const BLUE_LIGHT = '#EBF4FF'; // tint for active rows / info boxes
export const BG     = '#F5F8FC'; // page background (very light blue-white)
export const CARD   = '#FFFFFF';
export const TEXT   = '#1A1A1A';
export const TEXT_SUB = '#666666';
export const TEXT_MUTED = '#AAAAAA';
export const DIVIDER = '#E8EDF2';
export const LIVE_GREEN = '#2E7D32';
